import {Injectable} from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Account} from 'web-angular-client';
import {RefundDialogComponent} from '../component/refund-dialog/refund-dialog.component';
import {AlertService} from './alert.service';
import {AuthenticationService} from './authentication.service';

/**
 * Opens the refund dialog for an ecommerce account. Centralizes the guest-account guard (so the dashboards don't each
 * repeat it) and the modal wiring; the dialog itself owns the amount form, the refund API call, and the result view
 * (refund link on success, or the failure reason). Mirrors {@code ConfirmationService}'s NgbModal-open pattern.
 */
@Injectable({providedIn: 'root'})
export class RefundDialogService
{
    constructor(
        private readonly modalService: NgbModal,
        private readonly authenticationService: AuthenticationService,
        private readonly alertService: AlertService)
    {
    }

    open(account: Account | null): void
    {
        if (this.authenticationService.isGuestAdminUser())
        {
            this.alertService.error('Guest accounts cannot perform this action.', false);
            return;
        }
        if (account?.id == null)
        {
            return;
        }
        if ((account.amountPaid ?? account.amount ?? 0) <= 0)
        {
            this.alertService.error('This transaction has no amount available to refund.', false);
            return;
        }
        this.modalService.open(RefundDialogComponent, {
            size: 'md',
            centered: true,
            backdrop: 'static'
        }).componentInstance.account = account;
    }
}
